"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const errors_1 = require("@/common/errors");
function default_1({ error, confirm, onAlreadyCompanyInfoError, }) {
    var _a, _b, _c, _d, _e;
    const errorMsg = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.error_msg;
    const errorCode = (_e = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.meta) === null || _e === void 0 ? void 0 : _e.alert_type;
    const errorConfirm = (description) => (0, errors_1.alertConfirm)({ confirm, description });
    switch (errorMsg) {
        case 'ALREADY_COMPANY_INFO_ERROR':
            errorConfirm(i18next_1.default.t('이미 등록 완료되었어요'));
            onAlreadyCompanyInfoError();
            break;
        case 'NOT_COMPLETE_CREDIT_MEDIA_ERROR':
            errorConfirm(i18next_1.default.t('업로드 실패했어요. 잠시 후 다시 시도해 주세요!'));
            break;
        case 'NOT_FOUND_CREDIT_MEDIA_ERROR':
            errorConfirm(i18next_1.default.t('파일을 찾을 수 없어요. 잠시 후 다시 시도해 주세요!'));
            break;
        default:
            (0, errors_1.commonErrorConfirm)({
                confirm,
                errorCode,
                errorReason: errorMsg,
            });
    }
}
exports.default = default_1;
